import React, { useContext } from "react";
import { IoClose } from "react-icons/io5";
import { useApiWithAxios } from "src/hooks/useApi";
import CONSTANTS from "src/components/services/api";
import avatarGroup from "src/assets/Avatar group.png";
import { ChatTemplate } from "src/components/atoms/ChatTemplate";
import Cookies from "js-cookie";
import { MyContext } from "src/components/Context/MyContext";

const NewTemplates = ({ close, setInputValue }) => {
  const { userId } = useContext(MyContext);
  const roleId = Cookies.get("roleId");
  const selected_user_id = Cookies.get("selected_user_id");
  const bearerToken = Cookies.get("Token");
  const { data, error, loading } = useApiWithAxios(`${CONSTANTS.API_BASE}/chat_tamplates?coach_id=${roleId == "1" ? selected_user_id : userId}`, "GET", null, {
    headers: {
      Authorization: bearerToken,
    },
  });

  const handleSelectTemplate = (item) => {
    setInputValue(`${item.content}`);
    close();
  };
  return (
    <div className=" flex flex-col items-center w-full h-full">
      <div className="relative w-full mb-5">
        <IoClose size={20} className="text-gray-500 absolute top-4 right-3 cursor-pointer" onClick={() => close()} />
      </div>
      <div className="px-5 flex flex-col justify-center items-center">
        <img src={avatarGroup} alt="" />
        <h1 className="text-lg font-semibold text-[#181D27] text-center mt-5 mb-2">Chat Template</h1>
        <h6 className="text-sm font-semibold text-[#999696] text-center mb-8">Suggest a specific chat template you want to proceed</h6>
      </div>
      <div className="grid  md:grid-cols-2 gap-x-3 gap-y-0 overflow-y-auto max-h-80 md:ml-2 mx-1 md:mx-0 w-full">
        {data?.data?.map((item, i) => (
          <div key={item.id} onClick={() => handleSelectTemplate(item)}>
            <ChatTemplate data={item} Css="!rounded-full !my-2 !h-auto !w-fit md:mr-2" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewTemplates;
